module.exports = __webpack_public_path__ + "img/christian.d15445fc.jpg";